import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IComponent } from "../types";
import { IPagination } from "app/types";
import { initialState } from "./initialState";
import { set } from "lodash";

export const projectComponentSlice = createSlice({
  name: "componentState",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setButtonLoading(state, action: PayloadAction<boolean>) {
      state.buttonLoading = action.payload;
    },
    setFieldLoading(state, action: PayloadAction<boolean>) {
      state.fieldLoading = action.payload;
    },
    setComponentModalOpen(state, action: PayloadAction<boolean>) {
      state.isComponentModalOpen = action.payload;
    },
    setArchiveModalOpen(state, action: PayloadAction<boolean>) {
      state.isArchiveModalOpen = action.payload;
    },
    setEditComponentState(
      state,
      action: PayloadAction<{ isEdit: boolean; formData: IComponent }>,
    ) {
      // state.isEditComponent = action.payload.isEdit;
      state.form = action.payload.formData;
    },
    updateFormValue: (
      state,
      action: PayloadAction<{ key: keyof IComponent; value: string }>,
    ) => {
      set(state, `form.${action.payload.key}`, action.payload.value);
    },
    setArchiveComponentData(
      state,
      action: PayloadAction<{ _id: string; name: string } | null>,
    ) {
      state.archiveComponentData = action.payload;
    },
    setComponentsList(state, action: PayloadAction<IComponent[]>) {
      if (state.pagination.page === 1) {
        state.list = action.payload;
      } else {
        state.list = [...state.list, ...action.payload];
      }
    },
    clearComponentsList(state) {
      state.list = [];
    },

    setPagination(state, action: PayloadAction<IPagination>) {
      state.pagination = action.payload;
    },
    setComponentDetail(state, action: PayloadAction<IComponent>) {
      state.form = action.payload;
    },

    createComponent(
      state,
      action: PayloadAction<{ projectId: string; callback?: () => void }>,
    ) {
      state.buttonLoading = true;
    },
    resetForm(state) {
      state.form = initialState.form;
    },

    fetchComponentsList(
      state,
      action: PayloadAction<{
        projectId: string;
      }>,
    ) {
      state.loading = true;
    },
    fetchComponentDetails(state, action: PayloadAction<string>) {},
    updateComponent(
      state,
      action: PayloadAction<{ projectId: string; callback?: () => void }>,
    ) {
      state.buttonLoading = true;
    },
    archiveComponent(state, action: PayloadAction<string>) {
      const idx = state.list.findIndex((c) => c._id === action.payload);
      if (idx !== -1) {
        state.list[idx].isArchived = true;
      }
    },
  },
});

export const {
  actions: componentActions,
  reducer: componentReducer,
  name: componentSliceKey,
} = projectComponentSlice;
